<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="card-base baslikBg animated fadeInUp">
            <span>Sipariş Listesi</span>
        </div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col class="margin-bottom-10" :lg="24" :md="24" :sm="24" :xs="24">
                <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                text-color="gray">
                    <el-radio-button v-if="root || yetkili" label="1">
                        <i class="mdi mdi-cart-outline mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                        <span style="color: #13ce66">Teslim Edildi</span>
                    </el-radio-button>
                    <el-radio-button v-if="root || yetkili" label="2">
                        <i class="mdi mdi-cart-outline mdi-18px" style="color: #9a9a9a; margin-right: 5px"></i>
                        <span style="color: #9a9a9a">Onay Bekliyor</span>
                    </el-radio-button>
                    <el-radio-button label="4">
                        <i class="mdi mdi-cart-outline mdi-18px" style="color: #0075c3; margin-right: 5px"></i>
                        <span style="color: #0075c3">Hazırlanıyor</span>
                    </el-radio-button>
                    <el-radio-button v-if="root || yetkili" label="3">
                        <i class="mdi mdi-cart-outline mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                        <span style="color: #13ce66">Onaylandı</span>
                    </el-radio-button>
                    <el-radio-button v-if="root || yetkili" label="5">
                        <i class="mdi mdi-cart-outline mdi-18px" style="color: #f7ba2a; margin-right: 5px"></i>
                        <span style="color: #f7ba2a">Yolda</span>
                    </el-radio-button>
                    <el-radio-button v-if="root || yetkili" label="6">
                        <i class="mdi mdi-cart-outline mdi-18px" style="color: #88b0b4; margin-right: 5px"></i>
                        <span style="color: #88b0b4">İade</span>
                    </el-radio-button>
                    <el-radio-button v-if="root || yetkili" label="0">
                        <i class="mdi mdi-cart-outline mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                        <span style="color: #ec205f">Firma Red</span>
                    </el-radio-button>
                    <el-radio-button v-if="root || yetkili" label="7">
                        <i class="mdi mdi-cart-outline mdi-18px" style="color: #740800; margin-right: 5px"></i>
                        <span style="color: #740800">İptal</span>
                    </el-radio-button>
                </el-radio-group>
            </el-col>
            <el-table
                    border
                    stripe
                    :data="siparisList"
                    :row-key="row => row.msiparisId"
                    :expand-row-keys="expandRowKeys"
                    @expand-change="handleExpandChange"
                    style="width: 100%">
                <el-table-column
                        label="#"
                        width="55"
                        type="index">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="msiparisId"
                        label="Sipariş No"
                        width="150">
                </el-table-column>                               
                <el-table-column
                        sortable
                        prop="adSoyad"
                        label="İsim Soyisim"
                        width="200">
                </el-table-column>                
                <el-table-column
                        sortable
                        prop="telefon"
                        label="Telefon"
                        width="150">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="adres"
                        label="Adres"
                        width="auto">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="siparisYeri"
                        label="Sipariş Yeri"
                        width="150">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="siparisTarihi"
                        label="Sipariş Tarihi"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="zil"
                        label="Zile Basılsın mı?"
                        width="170"
                        :formatter = "formatZil">
                </el-table-column> 
                <el-table-column
                        label="Genel Toplam"
                        width="150">
                    <template slot-scope="props">
                        {{props.row.toplamFiyat}} CHF
                    </template>
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="150">
                    <template slot="header" slot-scope="scope">
                        <!--<el-input clearable v-on:clear="clearable" v-model="search" v-on:input="searchMethod"
                                  placeholder="Ara" size="mini"></el-input>-->
                    </template>
                    <template slot-scope="scope">
                        <el-tooltip content='Sipariş Detay' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    class="buttonEdit"
                                    icon="el-icon-info" type="text" style="color: #0075c3; margin-right: 5px"
                                    v-on:click="getSiparisDetay(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip content='Sipariş Detay' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    class="buttonEdit"
                                    icon="el-icon-printer" type="text" style="color: #13ce66; margin-right: 5px; margin-left: 0"
                                    v-on:click="getSiparisYazdir(scope.row.msiparisId)"></el-button>
                        </el-tooltip>
                        <el-tooltip content='Teslim Edildi' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon === '4' && yetkiList.sevkiyat"
                                    class="buttonEdit"
                                    icon="el-icon-check" type="text" style="color: #13ce66"
                                    v-on:click="siparisDurumChange(scope.row,scope.$index,siparisList,'1')"></el-button>
                        </el-tooltip>
                        <el-tooltip content='Teslim Edilemedi' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon === '4' && yetkiList.sevkiyat"
                                    class="buttonEdit" style="color: #ec205f"
                                    icon="el-icon-close" type="text"
                                    v-on:click="siparisDurumChange(scope.row,scope.$index,siparisList,'5')"></el-button>
                        </el-tooltip>
                        <el-dropdown v-if="root || yetkili" @command="handleCommand($event,scope.row,scope.$index)" trigger="click" style="padding: 8px 0">
                            <span class="el-dropdown-link">
                                <i class="mdi mdi-folder-search mdi-18px"></i>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="1" style="color: #13ce66; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">Teslim Edildi
                                </el-dropdown-item>
                                <el-dropdown-item command="2" style="color: #9a9a9a; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">Onay Bekliyor
                                </el-dropdown-item>
                                <el-dropdown-item command="3" style="color: #13ce66; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">Onaylandı
                                </el-dropdown-item>
                                <el-dropdown-item command="4" style="color: #0075c3; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">Hazırlanıyor
                                </el-dropdown-item>
                                <el-dropdown-item command="5" style="color: #f7ba2a; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">Yolda
                                </el-dropdown-item>
                                <el-dropdown-item command="6" style="color: #88b0b4; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">İade
                                </el-dropdown-item>
                                <el-dropdown-item command="0" style="color: #ec205f; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">Red
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100, 'Hepsi']"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="durumChangeDialog"
                width="30%"
                center>
            <span>"{{this.selection.adSoyad}}" müşterisinin sipariş durumunu değiştirmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="siparisDurumChange(selection,selectionIndex,siparisList,durum), durumChangeDialog = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="durumChangeDialog = false"></el-button>
                </span>
        </el-dialog>
        <el-dialog
                title='Sipariş Detayı'
                :visible.sync="detayVisible"
                width="80%"
                center>
            <span style="display: block; width: 100%">
                <el-row>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <el-row :gutter="20">
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="font-weight-600">
                                İsim Soyisim 
                            </el-col>
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="font-weight-600">
                                :
                            </el-col>
                            <el-col :lg="19" :md="19" :sm="24" :xs="24">
                                {{siparisDetay.adSoyad}}
                            </el-col>
                        </el-row>                        
                        <el-row :gutter="20">
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="font-weight-600">
                                Telefon 
                            </el-col>
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="font-weight-600">
                                :
                            </el-col>
                            <el-col :lg="19" :md="19" :sm="24" :xs="24">
                                {{siparisDetay.telefon}}
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="font-weight-600">
                                Sipariş Yeri 
                            </el-col>
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="font-weight-600">
                                :
                            </el-col>
                            <el-col :lg="19" :md="19" :sm="24" :xs="24">
                                {{siparisDetay.siparisYeri}}
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="font-weight-600">
                                Sipariş Tarihi 
                            </el-col>
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="font-weight-600">
                                :
                            </el-col>
                            <el-col :lg="19" :md="19" :sm="24" :xs="24">
                                {{siparisDetay.siparisTarihi}}
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="font-weight-600">
                                Toplam Fiyat 
                            </el-col>
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="font-weight-600">
                                :
                            </el-col>
                            <el-col :lg="19" :md="19" :sm="24" :xs="24">
                                {{siparisDetay.toplamFiyat}}
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="font-weight-600">
                                Ödeme Şekli 
                            </el-col>
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="font-weight-600">
                                :
                            </el-col>
                            <el-col :lg="19" :md="19" :sm="24" :xs="24">
                                <div v-if="siparisDetay.odemeSekli === '1'">Nakit</div>
                                <div v-else-if="siparisDetay.odemeSekli === '2'">Kredi Kartı</div>
                                <div v-else-if="siparisDetay.odemeSekli === '3'">Bedelsiz</div>
                                <div v-else-if="siparisDetay.odemeSekli === '4'">Online</div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="color:#92000A">
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="font-weight-600">
                                Zile Basılsın mı? 
                            </el-col>
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="font-weight-600">
                                :
                            </el-col>
                            <el-col :lg="19" :md="19" :sm="24" :xs="24">
                                <div v-if="siparisDetay.zil === '1'">Hayır</div>
                                <div v-else-if="siparisDetay.odemeSekli === '0'">Evet</div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="font-weight-600">
                                Sipariş Notu 
                            </el-col>
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="font-weight-600">
                                :
                            </el-col>
                            <el-col :lg="19" :md="19" :sm="24" :xs="24">
                                {{siparisDetay.siparisNotu}}
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="margin-top-20">
                                <el-table
                                        border
                                        stripe
                                        :data="siparisDetay.urun"
                                        style="width: 100%">
                                    <el-table-column
                                            label="Sıra"
                                            type="index">
                                    </el-table-column>
                                    <el-table-column
                                            prop="urunAdi"
                                            label="Ürün Adı"
                                            width="auto">
                                    </el-table-column>
                                    <el-table-column
                                            prop="eklenecek"
                                            label="Eklenecek Malzeme"
                                            width="200">
                                            <template slot-scope = "{row}">
                                                <div v-for = "malzeme in row.malzeme" v-if = "malzeme.durum == 1 ">{{ malzeme.malzemeAdi }}</div>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="cikacak"
                                            label="Çıkarılacak Malzeme"
                                            width="200">
                                            <template slot-scope = "{row}">
                                                <div v-for = "malzeme in row.malzeme" v-if = "malzeme.durum == 0"> {{ malzeme.malzemeAdi }}</div>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="adet"
                                            label="Adet"
                                            width="100">
                                    </el-table-column>
                                    <el-table-column
                                            prop="birimFiyat"
                                            label="Birim Fiyat"
                                            width="150">
                                    </el-table-column>
                                    <el-table-column
                                            prop="toplamFiyat"
                                            label="Toplam Fiyat"
                                            width="150">
                                    </el-table-column>
                                </el-table>
                            </el-col>
                        </el-row>

                    </el-col>
                </el-row>
            </span>
            <span slot="footer" class="dialog-footer">
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="detayVisible = false"></el-button>
                </span>
        </el-dialog>
        <el-dialog
                title='Sipariş Detay'
                :visible.sync="detayModal"
                width="60%"
                center>
            <span style="width: 100%; display: block">
                <el-row>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <div class="fisAlani">
                            <el-row style="margin-bottom: 10px">
                                <div v-if="detayBilgiler.adSoyad !==''">
                                    <div class="boldYazi fonts-16">Vorname Nachname:</div>
                                    <div class="fonts-16">
                                        {{detayBilgiler.adSoyad}}
                                    </div>
                                </div>
                                <div v-if="detayBilgiler.adres !==''">
                                    <div class="boldYazi fonts-16">Adresse:</div>
                                    <div class="fonts-16">
                                        {{detayBilgiler.adres}}
                                    </div>
                                </div>
                                <div v-if="detayBilgiler.siparisNotu !==''">
                                    <div class="boldYazi fonts-16">Bestellhinweis:</div>
                                    <div class="fonts-16">
                                        {{detayBilgiler.siparisNotu}}
                                    </div>
                                </div>
                            </el-row>
                            <el-row class="ozelBorder">
                                <el-col :span="16" class="ozelPadding borderRight boldYazi fonts-16">Produktname</el-col>
                                <el-col :span="4" class="ozelPadding borderRight ortala boldYazi fonts-16">Menge</el-col>
                                <el-col :span="4" class="ozelPadding ortala boldYazi sag fonts-16">Betrag</el-col>
                            </el-row>
                            <div v-for="(item,index) in detayList" :key="index" class="icRowDiv">
                                <el-row class="icRow">
                                    <el-col :span="16" class="ozelPadding borderRight fonts-16">
                                        {{ item.urunAdi }}
                                    </el-col>
                                    <el-col :span="4" class="ozelPadding borderRight ortala fonts-16">{{item.adet}}</el-col>
                                    <el-col :span="4" class="ozelPadding ortala sag fonts-16">{{item.toplamFiyat}} </el-col>
                                    <el-col :span="24" v-if="item.malzeme.length>0">
                                        <div class="boldYazi ekYer2" style="background: #f1f1f1">
                                            <span class="inline-block" style="color: brown; display: block; ">Extra Zutaten:</span>
                                            <hr>
                                            <div class="malzeme">
                                                <span v-for="i in item.malzeme" v-if="i.durum == 1" class="fonts-14" style="display:block">
                                                    {{i.malzemeAdi}} 
                                                    <div class="fiyatBilgisi">
                                                        {{i.fiyat !== 0 ? i.fiyat : ' - '}} 
                                                    </div>
                                                </span>                                              
                                            </div>    
                                            <br>                                              
                                            <span class="inline-block" style="color: brown;  display: block; ">Ich will das nicht</span>
                                            <hr>
                                            <div class="malzeme">
                                                <span v-for="i in item.malzeme" v-if="i.durum == 0" class="fonts-14" style="display:block">
                                                    {{i.malzemeAdi}}
                                                    <div class="fiyatBilgisi fonts-14">
                                                        <i style="color: red" class="mdi mdi-close"></i>
                                                    </div>
                                                </span>                                              
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-col :span="24" class="ozelBorder" style="background-color: #fff">
                                <div class="ozelPadding altCizgi" style="justify-content: space-between">
                                    <div class="fonts-16"> Bestellübersicht:</div>
                                    <div class="fonts-16">{{toplamAdet}} Produkt</div>
                                </div>

                                <div class="ozelPaddingv2">
                                    <div class="ortaYazi">Betrag</div>
                                    <div class="ortaYazi boldYazi">{{toplamTutar}}</div>
                                </div>
                            </el-col>

                            <el-col :span="24" style="border: 1px solid #4b5264;border-top: 0; background-color: #ffffff" class="toplamBolgesi">
                                <div class="ozelPaddingv2">
                                    <span class="ortaYazi">Gesamt <br> Betrag</span>
                                    <span class="sonTutar">{{toplamTutar}}</span>
                                </div>
                            </el-col>
                        </div>
                    </el-col>
                </el-row>
            </span>
            <span slot="footer" class="dialog-footer">
                    <el-button type="success"
                               size="mini"
                               @click="fisCikti(), detayModal = false">
                        <i class="mdi mdi-printer"></i> Yazdır
                    </el-button>
                    <el-button size="mini" type="danger"
                               @click="detayModal = false">
                        <i class="mdi mdi-close"></i>
                    </el-button>
                </span>
        </el-dialog>

    </div>

</template>
<script>
    import musteriService from '../../../WSProvider/MusteriService'
    import bildirimService from '../../../WSProvider/BildirimService'
    import notification from '../../../notification'
    import moment from "moment-timezone";
    import JQuery from 'jquery'
    let $ = JQuery;

    let base64 = require('base64_js');
    let userDataKader = "";

    export default {
        name: "SiparisListesi",
        data() {
            return {
                search: '',
                excelTable: [],
                islemTuru: '',
                userdataSiparis: {},
                userdataTopluCikti: {},
                filtersSorumlu: [],
                dialogVisibleUrunBaglanti: false,
                kargo: false,
                urundata: {},
                sizes: 10,
                page: 0,
                postPage: 0,
                total: null,
                siparisList: [],
                topluListe: [],
                yeniId: [],
                siparisDetayList: [],
                expandRowKeys: [],
                durumChangeDialog: false,
                disableCari: false,
                detayModal: false,
                detayList: [],
                detayBilgiler: '',
                toplamTutar: '',
                toplamAdet: 0,
                disableSiparis: false,
                topluDia: true,
                kargoFirma: '',
                sevkiyat: '',
                kargoTakipNo: '',
                selection: '',
                selectIcon: '2',
                radio: '2',
                selectionIndex: '',
                durum: '',
                root: false,
                yetkili: false,
                yetkiList: {
                    sevkiyat: false
                },

                siparisDetay:[],
                detayVisible: false,
            }
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataKader")) {
                var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
                if (userDataKader["tur"]) {
                    if (userDataKader["tur"] === '1') {
                        self.root = true;
                    } else if (userDataKader["tur"] === '2') {
                        self.yetkili = true;
                    } else if (userDataKader["tur"] === '3' && userDataKader["yetki"]) {
                        userDataKader["yetki"].forEach(function (value) {
                            switch (value.yetkiKodu) {
                                case 'YK-582007':
                                    self.yetkiList.sevkiyat = true;
                                    self.selectIcon = '4';
                                    self.radio = '4';
                                    break;

                            }
                        });
                    }
                }

            }
            this.siparisCount();
            this.getSiparisList();
        },
        methods: {
            formatZil (row){
                return row.zil == 1 ? "Hayır" : "Evet"
            },

            getSiparisYazdir(val){
                let self = this;
                this.toplamAdet= 0;
                musteriService.siparisDetay(val).then((response) => {
                    if (response.status === 200) {
                        response.data.urun.forEach(function (e) {
                            self.toplamAdet += parseInt(e.adet)
                        });
                        this.toplamTutar = response.data.toplamFiyat;
                        this.detayList = response.data.urun;
                        this.detayBilgiler = response.data;
                        this.detayModal = true
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            fisCikti(){
                barkodCikti()
            },
            getSiparisDetay(val){
                musteriService.siparisDetay(val.msiparisId).then((response) => {
                    if (response.status === 200) {
                        this.siparisDetay = response.data;
                        this.detayVisible = true;
                        console.log(this.siparisDetay)
                    }
                });
            },
            searchMethod(val) {
                if (val !== '') {
                    var dizi = [];
                    musteriService.siparisSearch(val, this.selectIcon).then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                dizi.push(e);
                            });
                            this.siparisList = dizi;
                        } else notification.Status(response.status, this)
                    })
                } else this.clearable();
            },
            clearable() {
                this.siparisList = [];
                this.getSiparisList();
                this.siparisCount();
            },
            handleExpandChange(row, expandedRows) {
                const msiparisId = row.msiparisId;
                this.siparisDetayList = row.detay;
                const lastId = this.expandRowKeys[0];
                this.expandRowKeys = msiparisId === lastId ? [] : [msiparisId];
            },
            handleSizeChange(val) {
                if(val.toString() === 'NaN'){
                    this.sizes = '';
                    this.postPage = '';
                }else{
                    this.sizes = val;
                }
                this.siparisCount();
                this.getSiparisList();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.siparisCount();
                this.getSiparisList();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.siparisCount();
                this.getSiparisList();
            },
            siparisCount() {
                musteriService.siparisCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data);
                    }
                });
            },
            handleCommand(command, row, index) {
                this.selection = row;
                this.selectionIndex = index;
                this.durum = command;
                this.durumChangeDialog = true;
            },
            getSiparisList() {
                musteriService.siparisListesi(this.postPage, this.sizes,this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.siparisList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            siparisDurumChange(selection, index, list, durum) {
                var mesaj = '';
                switch (durum) {
                    case '0':  mesaj =  'İptal Edildi'; break;
                    case '1':  mesaj =  'Teslim Edildi'; break;
                    case '2':  mesaj =  'Onay Bekliyor'; break;
                    case '3':  mesaj =  'Onaylandı'; break;
                    case '4':  mesaj =  'Hazırlanıyor'; break;
                    case '5':  mesaj =  'Yolda'; break;
                    case '6':  mesaj =  'İade Edildi'; break;
                    case '7':  mesaj =  'Firma Tarafından Reddedildi'; break;
                }
                musteriService.siparisDurumGuncelle(selection.msiparisId, durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status("success", this, "Durum değişikliği başarılı..");
                        list.splice(index, 1);
                        this.durumChangeDialog = false;
                        bildirimService.siparisGonder(selection.bildirimToken, selection.msiparisId +' nolu sipariş durumu "' +mesaj+' " olarak güncellendi', 'siparis', selection.msiparisId)
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },

        }
    }



    function barkodCikti() {
        const ciktiCSS = `
        div{
            border: none !important;
            padding:0 !important;
            margin: 0 !important;
            display: inline-block            
        }
        .inline-block{
            margin-top:15px
        }
        body {
            margin: 0 ;
            padding:0 0.5cm;
            width:7.2cm;
            font-family: monospace;
            font-size:14px
        }
        @page {
            margin: 0 9mm
        }
        .ozelPaddingv2 {
            display: flex;
            justify-content:space-between
        }
        .el-col-24 {
            width: 100%
        }
        .el-col-16 {
            width: 66.66667%;
        }
        .el-col-14 {
            width: 66.66667%;
        }
        .el-col-4 {
            width: 16.66667%;
        }
        .el-col-2 {
            display: none
        }
        .FisBosluk {
            display: block
        }
        .ozelBorder {
            border-bottom: 1px solid #000 !important;
            margin-bottom: 5px !important;
            padding-bottom: 5px !important;
        }
        .el-row {
            display: block;
            width:100%
        }
        .ortala {
            text-align:center;
            justify-content:center;
        }
        br {
            display:none
        }
        .icRowDiv {
            display: block
        }
        .boldYazi {
            font-weight: bold
        }
        .sag {
            text-align:right
        }
        .ekYer {
            background:transparent !important;
            margin-bottom: 5px!important;
            display:block;
            padding-left: 10px !important;
            padding-bottom: 10px !important;
            padding-top: 10px !important;
            white-space: pre-wrap; /* bu satırın eklenmesi gerekli */
        }
        .ekYer div {
            display:block
        }
        .icRowDiv .icRow{
            border-bottom: 1px solid #000 !important;
            margin-bottom: 5px !important;
            padding-bottom: 5px !important;
        }
        .toplamBolgesi {
            font-weight: bold
        }
        .fiyatBilgisi {
            text-align:right
        }
        .malzeme .fonts-14 {
            margin-right: 20px;
        }
        .altCizgi {
            display: none
        }
        .muhittin {
            display: block; float: left;
        }
    `;
        var openWindow = window.open("", "", "_blank,width=400,height=500");
        const tarih = moment().format('yyyy/MM/DD');
        const saat = moment().subtract(1, 'hours').format('HH:mm');
        const logo = '<img src="static/logo3.png" alt="logo" style="max-width: 100%; height: 50px"/>';
        openWindow.document.write('<div class="ortala" style="display: block !important;margin-top: 10px !important;filter: brightness(0)">' + logo + '</div>');
        openWindow.document.write('<div class="ortala" style="margin: 20px !important;">Aarauerstrasse 21 5116 Schinznach-Bad, <br style="display: block !important;"><br style="display: block !important;"> Tel 056 525 91 91</div>');
        openWindow.document.write('<div class="sag" style="display: block;margin-bottom: 25px !important;"><div style="float: left">' + tarih + '</div><div style="float: right">' + saat + '</div></div>');
        openWindow.document.write('<div class="FisBosluk">' + $(".fisAlani").html() + '</div>');
        openWindow.document.write('<style>' + ciktiCSS + '</style>');
        openWindow.document.write('<div style="display: block !important; text-align: center; margin-top: 20px !important;">MwSt. Nr. CHE-256.608.568</div>');
        openWindow.document.write('<div style="display: block !important; text-align: center; margin-top: 10px !important;">Danke für ihre Bestellung</div>');
        openWindow.focus();
        setTimeout(() => {
            openWindow.print();
        }, 1000);
        setTimeout(() => {
            openWindow.close();
        }, 1500)
    }

</script>

<style lang="scss">
    .el-table .info-row {
        background: rgba(125, 199, 225, 0.45);
    }

    .el-table .error-row {
        background: rgba(249, 0, 26, 0.08);
    }

    .el-table .success-row {
        background: rgba(3, 249, 0, 0.08);
    }

    .el-table .warning-row {
        background: rgba(245, 249, 0, 0.08);
    }
</style>
<style lang="scss" scoped>
    .refresh {
        color: #fff;
        float: right;
        padding: 0 !important;
        transition: all 0.5s;

    }

    .refresh:hover {
        transform: rotate(360deg);
    }

    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

    .ekYer2 {
        border-top: 1px solid #4b5264;
        padding-left: calc(8.33333% + 30px);
        padding-right: 60px;
        min-height: 44px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .ekYer2 span {
        position: relative;
        width: 100%;
        display: block;
        line-height: 22px;
    }

    .inline-block {
        display: inline-block;
        margin-right: 10px;
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }


    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 0 10px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }


    .el-radio-button--mini .el-radio-button__inner {
        display: flex;
        align-items: center;
    }
</style>

<style>
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: rgb(229, 245, 249) !important;
        border-color: rgb(229, 245, 249) !important;
    }
</style>
